<template>
  <ToggleSection
    label="Run Parameters"
    icon-classes="fa-solid fa-dna"
    :collapsed="!dv.isEditing"
  >
    <FieldGrid
      class="form-fields"
      :fields="[
        ['widget:instrumentData'],
        ['flowcell', 'flowcell_version'],
        ['lane'],
        ['runtype'],
        ['runmode', 'readlength'],
        ['chemistry'],
      ]"
      :dv="dv"
    />
  </ToggleSection>
</template>

<script>
import ToggleSection from '@/components/fields/ToggleSection.vue'
import FieldGrid from '@/components/fields/FieldGrid.vue'

export default {
  name: 'IlluminaRunParameters',
  components: {
    ToggleSection,
    FieldGrid,
  },
  props: {
    dv: { type: Object, required: true },
  },
}
</script>
